<form nz-form style="padding-top:12px;padding-right:12px"  autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24">Cơ sở</nz-form-label>
        <asc-autocomplete [ascModel]="SchoolControl" (ascModelChange)="changeSchool($event)"
          [placeholder]="'Chọn cơ sở'" [getListAC]="getSchoolACFn">
        </asc-autocomplete>
      </nz-form-item>
    </div>

    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24">Năm</nz-form-label>
        <asc-autocomplete [ascModel]="CourseControl" (ascModelChange)="changeCourse($event)"
          [placeholder]="'Chọn năm'" [getListAC]="getCourseACFn"></asc-autocomplete>
      </nz-form-item>
    </div>

    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24">Cấp học</nz-form-label>
        <asc-autocomplete [ascModel]="SchoolLevelControl" (ascModelChange)="changeSchoolLevel($event)"
          [placeholder]="'Chọn cấp học'" [getListAC]="getSchoolLevelACFn"></asc-autocomplete>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzRequired nzFor="rule" #label>Quy tắc</nz-form-label> 
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!" [nzValidateStatus]="lophocnienhoc.rule ? '' : 'error'">
          <input nz-input [(ngModel)]="lophocnienhoc.rule" [ngModelOptions]="{standalone: true}" (change)="addQuyTac($event.target.value)" type="text"
            placeholder="Nhập quy tắc" [jAutofocus]>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzRequired nzFor="quantity" #label>Số lượng</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!" [nzValidateStatus]="lophocnienhoc.quantity ? '' : 'error'">
          <input nz-input [(ngModel)]="lophocnienhoc.quantity" [ngModelOptions]="{standalone: true}" (change)="addSoLuong($event.target.value)" name="tenCs" type="text"
            placeholder="Nhập số lượng">
        </nz-form-control>
      </nz-form-item>
    </div>
    <h4><span>VD:
        {{sl == 1 ? resultQT + sl : sl >1 ? resultQT + '1...' + resultQT  + sl : ''}}</span>
    </h4>
    <!-- <div nz-col nzSm="24" nzMd="24">
        <div nz-row>
          <div nz-col nzSm="8" nzMd="8">
            <nz-form-item><label nz-checkbox>Chọn phân hệ là GDHN</label></nz-form-item>
          </div>
          <div nz-col nzSm="8" nzMd="8">
            <nz-form-item><label nz-checkbox>Chọn nhập số phòng hỗ trợ là GDHN</label></nz-form-item>
          </div>
          <div nz-col nzSm="8" nzMd="8">
            <nz-form-item><label nz-checkbox>Chọn cấp trực thuộc là GDHN</label></nz-form-item>
          </div>
        </div>
      </div> -->
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right">
      <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Lưu &
        Đóng</button>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
      <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button>
    </div>
  </div>
</form>